import { requestFromApi } from '.';
export const fetchTranslationData = async (options) => {
    const { data: translationsData, error: { message: translationsError } = {} } = await requestFromApi(options, {
        method: 'GET',
        url: 'translations'
    });
    return {
        translationsData,
        translationsError
    };
};
